import * as R from 'ramda'
import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { Col, Row } from '.../../../components/Layout/FlexGrid'
import AspectBox from '../../../components/AspectBox'
import { useTranslation } from '../../../i18n'
import FundraisingBannerSvg from '../../../public/static/images/personal-fundraising-banner-4-3.svg'
import { getFontSize, objectFit } from '../../../utils/cssUtils'
import CardWrapper from '../../CardWrapper'

const Wrapper = styled(CardWrapper)`
  width: 100%;
  padding: 24px;
`
const StyledAspectBox = styled(AspectBox)`
  border-radius: 4px;
  overflow: hidden;
`
const StyledFundraisingBanner = styled(FundraisingBannerSvg)`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: 'cover';
  ${objectFit('cover')}
`
const Title = styled.span`
  font-size: ${getFontSize('title')};
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 8px;
`
const Description = styled.p`
  text-align: justify;
  font-size: ${getFontSize('body2')};
  line-height: 1.87;
  letter-spacing: 1.07px;
  margin-bottom: 16px;
`

const CtaCard = ({ button, className }) => {
  const { t } = useTranslation('common')

  const isAppview = useSelector(R.path(['appState', 'isAppview']))

  return (
    <Wrapper className={className}>
      <Row gutter={{ xl: 8, md: 24, xs: 8 }}>
        <Col xl={24} md={10} xs={24}>
          <StyledAspectBox ratio={75}>
            <StyledFundraisingBanner />
          </StyledAspectBox>
        </Col>
        <Col xl={24} md={14} xs={24}>
          <Title>{t('personalFundraising.ctaTitle')}</Title>
          <Description>
            {!isAppview && t('personalFundraising.summary')}
          </Description>
          {button}
        </Col>
      </Row>
    </Wrapper>
  )
}

export default CtaCard
